import React from "react";
import TabbedServicesSection from "../components/TabbedServicesSection";

const ServicesPage = () => {
  return (
    <div style={{ marginTop: "100px" }}>
      {/* Removed the duplicate heading */}
      <TabbedServicesSection />
    </div>
  );
};

export default ServicesPage;
